import { IconX } from "@tabler/icons";
import React from "react";
import ReactModal from "react-modal";
import "./youTubeModal.css";

type YouTubeModalProps = {
    videoId?: string,
    isOpen: boolean,
    onClose: ()=>void,
}

// Features the YouTube frame needs for 360 playback. A cross-origin frame is
// denied all of these unless they are delegated to it here, and the site's
// Permissions-Policy header must allow them for www.youtube.com as well.
const ALLOW = [
    "accelerometer",
    "gyroscope",
    "magnetometer",
    "xr-spatial-tracking",
    "autoplay",
    "encrypted-media",
    "picture-in-picture",
    "fullscreen",
].join("; ");

const embedUrl = (videoId:string) => {
    const params = new URLSearchParams({
        autoplay: "1",
        rel: "0",
        fs: "1",
        cc_load_policy: "1",
        iv_load_policy: "1",
    });
    return `https://www.youtube.com/embed/${videoId}?${params.toString()}`;
}

const YouTubeModal : React.FC<YouTubeModalProps> = ({videoId, isOpen, onClose}) => {
    if (!videoId) { return null; }
    return <ReactModal
        className="jobjump-youtube-modal"
        overlayClassName="jobjump-modal-overlay"
        isOpen={isOpen}
        onRequestClose={onClose}>
        <div className="text-right">
            <IconX className="video-close-button" height={50} width={50} onClick={onClose} />
        </div>
        <div className="jobjump-youtube-modal-frame">
            <iframe
                title="YouTube video player"
                src={embedUrl(videoId)}
                allow={ALLOW}
                allowFullScreen />
        </div>
    </ReactModal>
}

export default YouTubeModal;
